(function () {
    window.HolidayCampChildList = function ($el) {
        this.$el = $el
        this.$listContainer = this.$el.find('.list-container')
        this.template = Handlebars.compile(this.$el.find('.add-row-template').html())
        this.list = this.$el.data('child-list')
        this.emptyRow = {
            first_name: '',
            last_name: '',
            age: '',
            medical_info: ''
        }

        this.$el.on('click', '.remove-row', this.remove.bind(this))
        this.$el.on('click', '.add-row', this.add.bind(this))

        this.render()

        return this
    }

    HolidayCampChildList.prototype.remove = function (event) {
        event.preventDefault()
        var $remove = $(event.target).closest('.attending-child-row')
        var i = this.$listContainer.find('.attending-child-row').index($remove)
        this.updateListValues()
        this.list.splice(i, 1)
        this.render()
    }

    HolidayCampChildList.prototype.add = function (event) {
        event.preventDefault()
        this.updateListValues()
        this.list.push(this.emptyRow)
        this.render()
    }

    HolidayCampChildList.prototype.updateListValues = function () {
        this.list = this.$listContainer.find('input').serializeObject().children
    }

    HolidayCampChildList.prototype.render = function () {
        if (this.list.length == 0) {
            this.list.push(this.emptyRow)
        }

        this.$listContainer
            .html(this.template(this.list))
            .children()
            .show()
    }
    
    $('.holiday-camp-child-list').each(function () {
        new HolidayCampChildList($(this))
    })
})()
